import React from "react";

const ExperienceCentre = () => {
  return (
    <section
      className="experience-section py-5"
      style={{
        backgroundColor: "#f9f9f9",
      }}
    >
      <div className="container">
        <div
          className="d-flex flex-column flex-lg-row align-items-center justify-content-between shadow-sm rounded-4 overflow-hidden"
          style={{
            borderRadius: "20px",
            overflow: "hidden",
            backgroundColor: "#fff",
          }}
        >
          {/* Left - Text Section */}
          <div
            className="p-5 flex-grow-1 d-flex flex-column justify-content-center"
            style={{
              flex: "0 0 50%",
              color: "#fff",
              background: "linear-gradient(135deg, #071836 0%, #112c5a 100%)",
              clipPath: "polygon(0 0, 85% 0, 100% 50%, 85% 100%, 0 100%)",
              borderTopLeftRadius: "20px",
              borderBottomLeftRadius: "20px",
              minHeight: "360px",
            }}
          >
            <h2
              className="fw-bold mb-3"
              style={{
                fontSize: "2rem",
                lineHeight: "1.4",
                color: "#fff",
              }}
            >
              Discover Inspiring Designs <br />
              at the{" "}
              <span style={{ color: "#ff5b5b" }}>MeHome Experience Centre</span>
            </h2>

            <p
              className="mb-4"
              style={{ fontSize: "1.05rem", lineHeight: "1.6", color: "#e3e8ef" }}
            >
              Step into our Experience Centres to explore elegant interiors,
              smart designs, and creative spaces that reflect your lifestyle.
              Experience first-hand how MeHome transforms dreams into reality.
            </p>

            <a
              href="/contact-us"
              className="btn fw-semibold"
              style={{
                backgroundColor: "#ff5b5b",
                color: "#fff",
                border: "none",
                borderRadius: "30px",
                padding: "10px 26px",
                fontSize: "1rem",
                width: "fit-content",
                transition: "all 0.3s ease",
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = "#ff3434")}
              onMouseOut={(e) => (e.target.style.backgroundColor = "#ff5b5b")}
            >
              Visit Us →
            </a>
          </div>

          {/* Right - Background Image Section */}
          <div
            className="flex-grow-1"
            style={{
              flex: "0 0 50%",
              backgroundImage: "url('/imgs/discover-inspiring-designs-experience-centre.jpg')",
              backgroundSize: "cover",
              backgroundPosition: "center",
              borderTopRightRadius: "20px",
              borderBottomRightRadius: "20px",
              minHeight: "360px",
            }}
          ></div>
        </div>
      </div>
    </section>
  );
};

export default ExperienceCentre;
